
export default {
	props: {
		showModal: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: 'auto'
		},
        closeModal:{
			type: Function,
        }
	},
	data() {
		return {}
	},
	methods: {
	}
}
